import { FeeScheduleGroup } from '@bariendo/lib/receivables';
import { useMedplum } from '@medplum/react';
import { useCallback, useEffect, useState } from 'react';
import { fetchBotRead } from '@/services/botCalls';

/** The fee schedule, every version, grouped by payor and location (BAR-3039). */
export function useFeeSchedule(): {
  groups: FeeScheduleGroup[];
  loading: boolean;
  error: string | undefined;
  reload: () => void;
} {
  const medplum = useMedplum();
  const [groups, setGroups] = useState<FeeScheduleGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();
  const [reloadKey, setReloadKey] = useState(0);
  const reload = useCallback(() => setReloadKey((key) => key + 1), []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchBotRead<{ schedule: { groups: FeeScheduleGroup[] } }>(medplum, 'create-treatment-payment', {
      operation: 'feeSchedule',
    })
      .then(({ schedule }) => {
        if (!cancelled) {
          setGroups(schedule.groups);
          setError(undefined);
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          // Rates from before the failure would read as current (BAR-3125).
          setGroups([]);
          setError(err instanceof Error ? err.message : 'Could not load the fee schedule');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [medplum, reloadKey]);

  return { groups, loading, error, reload };
}
